<template>
    <div class="">
        <div class="content-block nav-header">
            <h3>Economic Optimal Dispatch </h3>
            <div style="display: flex">
                <div class="dx-card"><DxButtonGroup :items = "graphControl"
                    :on-item-click="refresh"
                     styling-mode="text"/></div>
                <div class="dx-card px-1"><DxSelectBox
                    :items="refresh_period_arr"
                    :value="10000"
                    value-expr="value"
                    display-expr="text"
                    height="28"
                    width="80"
                    :on-selection-changed="change_period_fn"
                    styling-mode="underlined"
                /></div>
            </div>
            
        </div>
        
        <div class="content-block" >
            <div class="dx-card p-3 position-relative">
            <div class="title-graph"><h5> Power Profile </h5></div>
            <DxChart :size="{height:300}" :data-source="power_profile" >
                <DxCommonSeriesSettings type="line" argument-field="time" />
                <DxSeries value-field="value" name="Power Profile [MWh]"  :point="{visible: false}"/>
                <DxArgumentAxis
                  :tick-interval="1000*60*60"
                  :label="{customizeText:customizeHours}"/>
            </DxChart>
            </div>
        </div>
     </div>
</template>
<script>
import { ref } from 'vue';
import RawDataService from '../services/RawDataServiceTemplate';
import {  DxChart, DxCommonSeriesSettings, DxSeries, DxArgumentAxis} from 'devextreme-vue/chart';
import DxButtonGroup from 'devextreme-vue/button-group';
import DxSelectBox from 'devextreme-vue/select-box';

export default {
  name: 'EODMonitor',
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxButtonGroup,
    DxSelectBox
  },
  data(){
    return {
        graphControl: [{
            icon: "refresh",
            style: "bold",
            hint: "refresh"
        }]
    }
  },
  setup(){
    // API calls
    const algorithmsDataService = new RawDataService(`algorithms/eod`);

    // chart
    const power_profile = new ref([])
    const refresh_period_arr = [
        {value:5000, text:'5s'},
        {value:10000, text:'10s'},
        {value:30000, text:'30s'},
        {value:0, text:'none'}]
    let refresh_timer ;
    const refresh = async () =>{
        algorithmsDataService.getAll().then(res=>{
          power_profile.value = []
          if(res.data.currentPowerProfile.datetime_unix_ms){
            for(var i=0;i<res.data.currentPowerProfile.datetime_unix_ms.length;i++){
              power_profile.value.push({
                  time: res.data.currentPowerProfile.datetime_unix_ms[i],
                  value: res.data.currentPowerProfile.value[i]
              })
            }
          }   
        })
    }
    const customizeHours = ( value ) => {
      var date = new Date(value.value)
      return formatDate(date);
    };
    function formatDate(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes ;
      return strTime;
    }
    
    function startInterval(time) {
      let refresh_timer;
      if( time > 0) 
        refresh_timer = setInterval(() => {
            refresh()
        }, time ); // 1000 milisegundos = 1 segundo
      
      return refresh_timer
    }

    function stopInterval(refresh_timer) {
      clearInterval(refresh_timer);
    }

    function change_period_fn(e){
      console.log('new refresh interval:'+ e.selectedItem.value)
      if(e.selectedItem.value > 0){
        stopInterval(refresh_timer)
        refresh() 
        refresh_timer = startInterval(e.selectedItem.value)
      }else{
        stopInterval(refresh_timer) 
      }
    }

    // init chart
    refresh()
    refresh_timer = startInterval(10000)
   
        
    return {
        power_profile,
        refresh_period_arr,
        change_period_fn,
        refresh,
        customizeHours
    }
  }
}
</script>

<style lang="scss">
@import url('../themes/base.scss');
.nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.home-container {
  max-width: 1450px;
  margin: 0 auto;
}

.title-graph{
  text-align: center
}
</style>